// extracted by mini-css-extract-plugin
module.exports = {"root":"hkwlP","order-details-container":"_3PCnr","orderDetailsContainer":"_3PCnr","section":"_1VhBb","section-item":"_2_cgI","sectionItem":"_2_cgI"};